module.exports = __webpack_public_path__ + "static/media/ex-amt.005bac7a.png";